import React from "react";
import {FormattedMessage} from "react-intl";

const MediaSection = () => (
  <section id="medias" className="medias">
    <div className="container" data-aos="fade-up">
      <h2><FormattedMessage id="media.title" /></h2>
      <div className="row">
        <div className="col-lg-4">
          <div className="post-box">
            <div className="post-img">
              <img
                  src="assets/img/medias/media-13.jpg"
                  className="img-fluid"
              />
            </div>
            <span className="post-date">06 mai 2025</span>
            <h3 className="post-title">
              Étienne Comtois finaliste au concours « La preuve par l’image »
            </h3>
            <a
                href="https://arbrenvil.uqam.ca/etienne-comtois-finaliste-au-concours-la-preuve-par-limage"
                target="_blank"
                className="readmore stretched-link mt-auto"
            >
              <span>
                <FormattedMessage id="see_more"/>
              </span>
            </a>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="post-box">
            <div className="post-img">
              <img
                  src="assets/img/medias/media-12.jpg"
                  className="img-fluid"
              />
            </div>
            <span className="post-date">19 avril 2025</span>
            <h3 className="post-title">
              Forêts urbaines | Verdir nos villes, un petit projet à la fois
            </h3>
            <a
                href="https://www.lapresse.ca/cinema/entrevues/2025-04-19/forets-urbaines/verdir-nos-villes-un-petit-projet-a-la-fois.php?sharing=true"
                target="_blank"
                className="readmore stretched-link mt-auto"
            >
              <span>
                <FormattedMessage id="see_more"/>
              </span>
            </a>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="post-box">
            <div className="post-img">
              <img
                  src="assets/img/medias/media-11.jpg"
                  className="img-fluid"
              />
            </div>
            <span className="post-date">16 avril 2025</span>
            <h3 className="post-title">
              «Forêts urbaines»: militer pour la nature en pleine ville
            </h3>
            <a
                href="https://www.ledevoir.com/culture/cinema/868051/forets-urbaines-militer-nature-pleine-ville"
                target="_blank"
                className="readmore stretched-link mt-auto"
            >
              <span><FormattedMessage id="see_more"/></span>
            </a>
          </div>
        </div>
      </div>
      <div className="text-center text-lg-center">
        <a
            href="/medias"
            className="btn scrollto d-inline-flex align-items-center justify-content-center align-self-center"
        >
          <span><FormattedMessage id="media.all_media"/></span>
        </a>
      </div>
    </div>
  </section>
);

export default MediaSection;
